<div class="app-loading" *ngIf="loading">
  <h4 class="text-splash">
    Carregando calendário, por-favor aguarde!
  </h4>
  <div class="content-spinner">
    <svg class="spinner" viewBox="25 25 50 50">
      <circle
        class="path"
        cx="50"
        cy="50"
        r="20"
        fill="none"
        stroke-width="2"
        stroke-miterlimit="10"
      />
    </svg>
  </div>
</div>
<mat-card
  class="container card-no-icon bg-white mat-elevation-z5"
  *ngIf="!loading"
>
  <mat-card-header class="border-bottom d-flex justify-content-between">
    <mat-card-title class="font-light">
      Calendário de agendamentos
      <i class="pi pi-fw pi-calendar text-primary"></i
    ></mat-card-title>
    <span class="font-light fs-normal">
      {{ "Total de " + agendamentos.length + " agendamentos marcados" }}
    </span>
  </mat-card-header>
  <mat-card-content class="mt-2">
    <div class="row text-center mb-3">
      <div class="col-md-4 flex align-items-center justify-content-center">
        <button
          pButton
          pRipple
          icon="pi pi-fw pi-chevron-left"
          text
          severity="help"
          rounded
          mwlCalendarPreviousView
          pTooltip="Mês anterior"
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="loadAgendamentos()"
        ></button>
        <button
          pButton
          pRipple
          icon="mdi mdi-calendar-today-outline"
          label="Data de hoje"
          iconPos="right"
          outlined
          severity="help"
          mwlCalendarToday
          [(viewDate)]="viewDate"
          (click)="loadAgendamentos()"
        ></button>
        <button
          mwlCalendarNextView
          [view]="view"
          [(viewDate)]="viewDate"
          (viewDateChange)="loadAgendamentos()"
          pButton
          pRipple
          pTooltip="Próximo mês"
          icon="pi pi-fw pi-chevron-right"
          text
          severity="help"
          rounded
        ></button>
      </div>
      <div class="col-md-4">
        <h4 class="text-uppercase">
          {{ viewDate | calendarDate: view + "ViewTitle" }}
        </h4>
      </div>
      <div
        class="col-md-4"
        *ngIf="checkDisponibilidade('POST', '', '/agendamentos')"
      >
        <button
          pButton
          pRipple
          label="Marcar agendamento"
          icon="mdi mdi-calendar-edit-outline"
          severity="primary"
          rounded
          outlined
          (click)="showAddDialog()"
          iconPos="right"
        ></button>
      </div>
    </div>
    <!-- template customizado para o calendário -->
    <ng-template #customCellTemplate let-day="day" let-locale="locale">
      <div
        class="cal-cell-top"
        [pTooltip]="day.badgeTotal > 0 ? 'Visualizar agendamentos' : ''"
      >
        <div class="cell-totals" *ngIf="day.badgeTotal > 0">
          <span
            *ngFor="
              let group of groupEvents(day.events)
                | slice
                  : 0
                  : (groupEvents(day.events).length > 2
                      ? 2
                      : groupEvents(day.events).length);
              index as i
            "
            style="margin-left: 2px;margin-right: 2px; color: white;"
            [style.background-color]="group.color"
            class="badge badge-pill "
          >
            {{
              group.paciente.length > 10
                ? group.paciente.slice(0, 10) + "..."
                : group.paciente.slice(0, 10)
            }}
            -
            {{
              group.local_agendamento.length > 10
                ? group.local_agendamento.slice(0, 10) + "..."
                : group.local_agendamento.slice(0, 10)
            }}
            ({{ group.data_hora | date: "shortTime" }})
          </span>
        </div>
        <div
          class="cal-day-number flex align-items-center justify-content-between width-100 mr-0 pl-3 pr-3"
        >
          <div>
            <p-badge
              size="large"
              pTooltip="Tem mais agendamentos"
              *ngIf="groupEvents(day.events).length > 2"
              [value]="groupEvents(day.events).length - 2 + '+'"
              severity="primary"
            ></p-badge>
          </div>
          <div>{{ day.date | calendarDate: "monthViewDayNumber":locale }}</div>
        </div>
      </div>
    </ng-template>

    <!-- tipo de visualização para mês -->
    <mwl-calendar-month-view
      [viewDate]="viewDate"
      [events]="agendamentos"
      [refresh]="refresh"
      [cellTemplate]="customCellTemplate"
      (dayClicked)="dayClicked($event.day)"
    >
    </mwl-calendar-month-view>
  </mat-card-content>
  <div class="w-100 d-flex justify-content-around flex-wrap mt-3">
    <div class="d-flex align-items-center">
      <span class="font-light uppercase fs-normal">Criado</span>
      <i
        class="pi pi-fw pi-circle-fill ml-2"
        [style]="'color: ' + cores.CRIADO.primary"
      ></i>
    </div>
    <div class="d-flex align-items-center">
      <span class="font-light uppercase fs-normal">Em andamento</span>
      <i
        class="pi pi-fw pi-circle-fill ml-2"
        [style]="'color: ' + cores.EM_ANDAMENTO.primary"
      ></i>
    </div>
    <div class="d-flex align-items-center">
      <span class="font-light uppercase fs-normal">Concluída</span>
      <i
        class="pi pi-fw pi-circle-fill ml-2"
        [style]="'color: ' + cores.CONCLUIDA.primary"
      ></i>
    </div>
    <div class="d-flex align-items-center">
      <span class="font-light uppercase fs-normal">Cancelada</span>
      <i
        class="pi pi-fw pi-circle-fill ml-2"
        [style]="'color: ' + cores.CANCELADA.primary"
      ></i>
    </div>
  </div>
</mat-card>
